import { FontStyle } from "../../../../base/styles";
import clsx from "clsx";

export const SelectFontStyle = ({ title, value, className, onChange }:{
    title: string,
    value?: FontStyle,
    className?: string,
    onChange: (value?: FontStyle) => void,
}) => {
    const handleOnSelectionChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const newValue = e.target.value as FontStyle;
        newValue ? onChange(newValue) : onChange(undefined);
    }

    return (
        <div className={clsx(className, "field-group mb-2")}>
            <label className="fs-8 fw-bold text-gray-600">{title}</label>
            <select
                onChange={handleOnSelectionChange}
                value={value || ""}
                className="form-select form-select-sm form-control-xs">
                <option></option>
                <option value={FontStyle.Normal}>Normal</option>
                <option value={FontStyle.Italic}>Italic</option>
            </select>
        </div>
    )
}